import '../general/localStorage.js';

(function () {
    // allowed domains
    const allowedDomains = /^.*?\.donorschoose\.org/;

    function verifyOrigin(origin) {
        const domain = origin.replace(/^https?:\/\/|:\d{1,4}$/g, '').toLowerCase();

        return domain.match(allowedDomains);
    }

    function handleRequest(event) {
        if (verifyOrigin(event.origin)) {
            let data = {};
            try {
                data = JSON.parse(event.data);
            } catch (e) {
                // Mystery bug: sometimes handleRequest is reached on page unload with an event.data
                // string that looks like _fsSetFrameId[SNOWMAN]797[SNOWMAN]1407989234662
                // -- note the funky snowman character.  Even more strange, when you add a breakpoint to the
                // beginning of this function, it is never reached (so it's hard to see the callstack),
                // and yet the uncommented alert does appear.
                //
                // Try/catch steps around this bug for now.
                // alert(e.message + " -- " + event.data);
            }
            if (data.action === 'get') {
                const value = window.dcLocalStorage.getValue(data.key);
                event.source.postMessage(JSON.stringify({ id: data.id, key: data.key, value: value }), event.origin);
            } else if (data.action === 'set') {
                window.dcLocalStorage.setValue(data.key, data.value, data.ttl);
                event.source.postMessage(JSON.stringify({ id: data.id, key: data.key, value: data.value }), event.origin);
            }
        }
    }

    if (window.addEventListener) {
        window.addEventListener('message', handleRequest, false);
    } else if (window.attachEvent) {
        window.attachEvent('onmessage', handleRequest);
    }
})();
